import React from 'react';

import { LinkCard, getCardPaths } from './link_card';

import type { Contact } from 'bundles/backoffice/contacts/types';
import type { ContactToolCall } from '../types';

interface ContactCardsProps {
  toolCalls: ContactToolCall[];
}

export function ContactCards({ toolCalls }: ContactCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path}>
          {(contact: Contact) => (
            <>
              <div className="fw-semibold text-truncate">{contact.label}</div>
              {contact.businessName && (
                <div className="small text-muted text-truncate">{contact.businessName}</div>
              )}
            </>
          )}
        </LinkCard>
      ))}
    </>
  );
}
